import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    maxHeight: "auto",
    paddingButtom: "20%",
    height: "100vh",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#5675D3",
    },
  },
  divPayung: {
    display: "none",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  payung: {
    height: "15%",
    position: "absolute",
    marginTop: "6%",
    marginLeft: "-8%",
  },
  gelombang: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  houseToko: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  content: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      textAlign: "center",
      marginLeft: "60%",
    },

    [theme.breakpoints.down("951")]: {
      marginLeft: 0,
    },
  },
  boxContent: {
    backgroundColor: "#fff",
    width: "550px",
    height: "470px",
    marginTop: "2%",
    zIndex: 999,

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      width: "450px",
      height: "auto",
      marginTop: "-6%",
      marginRight: "20%",
      borderRadius: "5px",
      boxShadow: "0px 6px 6px #726e6e73",
    },
    [theme.breakpoints.down("961")]: {
      marginTop: "-8%",
    },
    [theme.breakpoints.down("951")]: {
      marginTop: "3%",
      marginRight: 0,
    },
  },
  textContent: {
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20%",

    [theme.breakpoints.up("tablet")]: {
      fontSize: "20px",
      textAlign: "center",
      marginTop: "20%",
    },
  },
  textContent1: {
    fontWeight: "500",
  },
  textContent2: {
    color: "#5675D3",
  },
  textContent3: {
    backgroundColor: "#fff",
    display: "inline-block",
    width: "75%",
    fontSize: 18,
    fontWeight: "bold",
    borderRadius: "5px",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      display: "inline-block",
      width: "65%",
      fontSize: 14,
      fontWeight: "bold",
    },
    [theme.breakpoints.down("961")]: {
      width: "50%",
    },
  },
  garisContent: {
    height: 1,
    width: "2",
    backgroundColor: "grey",
    marginTop: -37,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 50,

    [theme.breakpoints.up("tablet")]: {
      height: 1,
      width: "1",
      backgroundColor: "grey",
      marginTop: -24,
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 20,
    },
  },
  textContent4: {
    marginTop: 30,
  },
  form: {
    marginTop: 90,
    width: "70%",
  },
  textCopyright: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "25%",
    [theme.breakpoints.up("tablet")]: {
      color: "#FFFF",
      fontSize: 10,
      marginTop: 15,
    },
  },
  formBottom: {
    width: "90%",
    height: "10%",

    [theme.breakpoints.up("tablet")]: {
      width: "90%",
      height: "7%",
    },
  },
  textHeaderKonfirmasi: {
    marginRight: "10%",
    marginLeft: "10%",
  },
  konfirmasih3: {
    color: "#0e0b0bb5",
    fontWeight: "10px",
    fontFamily: "sans-serif",
    fontSize: "12px",
  },
  textBox: {
    marginLeft: "5%",
    marginRight: "5%",
    marginBottom: "0",
  },
  textBoxBody: {
    textAlign: "left",
    marginTop: "8%",
    backgroundColor: "#695d5d40",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    boxShadow: "0px 4px 8px #9E9E9E",
  },
  textBoxRight: {
    fontFamily: "sans-serif",
    fontSize: "12px",
    marginLeft: "5%",
    marginRight: "2%",
    marginBottom: "0%",
    textTransform: "capitalize",
    width: "30%",
  },
  textBoxLeft: {
    fontFamily: "sans-serif",
    fontSize: "12px",
    marginRight: "2%",
    textTransform: "capitalize",
  },
  inputTest: {
    padding: "",
    "& .MuiOutlinedInput-input": {
      padding: "14px",
      paddingLeft: "0",
    },
  },
  link: {
    color: "#537ED4",
    textDecoration: "none",
    marginLeft: "5px",
    cursor: "pointer",
    "&:hover": {
      color: "#3333B0",
    },
  },
}));
export default useStyles;
